import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import SectionIndex from "@/components/landing/SectionIndex";
import AboutTeacher from "@/components/landing/AboutTeacher";
import Offerings from "@/components/landing/Offerings";
import Testimonials from "@/components/landing/Testimonials";
import LevelTestCTA from "@/components/landing/LevelTestCTA";
import Niveis from "@/components/landing/Niveis";
import Methodology from "@/components/landing/Methodology";
import FAQ from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";
import ExitIntent from "@/components/landing/ExitIntent";
import LeadMagnet from "@/components/landing/LeadMagnet";
import LeadMagnetA1 from "@/components/landing/LeadMagnetA1";
import Booking from "@/components/landing/Booking";
import Newsletter from "@/components/landing/Newsletter";
import ReelsSection from "@/components/landing/ReelsSection";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#f4f1ea] text-[#1e2a5a]">
      <Header />
      <main>
        <Hero />
        <SectionIndex />
        <AboutTeacher />
        <Offerings />
        <Niveis />
        <LeadMagnetA1 />
        <Methodology />
        <Testimonials />
        <ReelsSection />
        <LeadMagnet />
        <Newsletter />
        <FAQ />
        <LevelTestCTA />
        <Booking />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <ExitIntent />
    </div>
  );
}
